import React from 'react';
import { FileCheckIcon, ClockIcon, CheckCircle2Icon, XCircleIcon, AlertCircleIcon, TrendingUpIcon, BarChart3Icon, BellIcon, EyeIcon, TargetIcon, ZapIcon } from 'lucide-react';
export function Manage() {
  return <section id="gestion" className="py-8 md:py-28 bg-[#E8EDF5] relative overflow-hidden" data-id="element-1220">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#2B5FD9]/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-1221" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1E2A3A]/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" data-id="element-1222" />

      <div className="container mx-auto max-w-7xl px-4 relative z-10" data-id="element-1223">
        <div className="text-center mb-6 md:mb-16" data-id="element-1224">
          <h2 className="text-xl md:text-3xl font-bold mb-2 md:mb-4 text-[#0A1628]" data-id="element-1225">
            Nuestro superpoder
          </h2>
          <p className="text-sm md:text-base text-[#6B7280] max-w-2xl mx-auto" data-id="element-1226">
            <span className="md:hidden" data-id="element-1227">
              Te mostramos tus posibilidades reales.
            </span>
            <span className="hidden md:inline" data-id="element-1228">
              Hacemos visible lo que el mercado esconde. Las instituciones
              financieras no te dicen la verdad completa. Los ejecutivos empujan
              sus metas. La industria es un laberinto.
            </span>
          </p>
          <p className="text-sm md:text-base text-[#0A1628] font-medium max-w-2xl mx-auto mt-2 md:mt-3" data-id="element-1229">
            <span className="md:hidden" data-id="element-1230">Eso no lo hace nadie.</span>
            <span className="hidden md:inline" data-id="element-1231">
              Creditual te muestra exactamente tus posibilidades reales y qué
              hacer para que te aprueben. Eso no lo hace nadie.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-1232">
          {/* Left side - Visual mockups - Hidden on mobile */}
          <div className="hidden lg:block relative h-[600px] order-2 lg:order-1" data-id="element-1233">
            {/* Main dashboard card - center */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[380px] bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 z-10 hover:scale-105 transition-transform duration-300" data-id="element-1234">
              <div className="flex items-center justify-between mb-4" data-id="element-1235">
                <h3 className="text-lg font-bold text-[#0A1628]" data-id="element-1236">
                  Mis Solicitudes
                </h3>
                <div className="flex items-center gap-2 text-xs text-[#6B7280]" data-id="element-1237">
                  <TrendingUpIcon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1238" />
                  <span data-id="element-1239">4 instituciones</span>
                </div>
              </div>

              {/* Application items */}
              <div className="space-y-3" data-id="element-1240">
                <div className="bg-[#2B5FD9]/10 rounded-lg p-3 border border-[#2B5FD9]/20" data-id="element-1241">
                  <div className="flex items-center justify-between mb-2" data-id="element-1242">
                    <div className="flex items-center gap-2" data-id="element-1243">
                      <CheckCircle2Icon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1244" />
                      <span className="text-sm font-semibold text-[#0A1628]" data-id="element-1245">
                        Institución 1
                      </span>
                    </div>
                    <span className="text-xs font-bold text-[#2B5FD9]" data-id="element-1246">
                      2.8%
                    </span>
                  </div>
                  <div className="w-full bg-[#2B5FD9]/20 rounded-full h-1.5" data-id="element-1247">
                    <div className="bg-[#2B5FD9] h-1.5 rounded-full w-full" data-id="element-1248" />
                  </div>
                </div>

                <div className="bg-blue-50 rounded-lg p-3 border border-blue-100" data-id="element-1249">
                  <div className="flex items-center justify-between mb-2" data-id="element-1250">
                    <div className="flex items-center gap-2" data-id="element-1251">
                      <ClockIcon className="h-4 w-4 text-blue-600" data-id="element-1252" />
                      <span className="text-sm font-semibold text-[#0A1628]" data-id="element-1253">
                        Institución 2
                      </span>
                    </div>
                    <span className="text-xs font-bold text-blue-600" data-id="element-1254">
                      3.2%
                    </span>
                  </div>
                  <div className="w-full bg-blue-100 rounded-full h-1.5" data-id="element-1255">
                    <div className="bg-blue-600 h-1.5 rounded-full w-3/5" data-id="element-1256" />
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-3 border border-gray-200" data-id="element-1257">
                  <div className="flex items-center justify-between" data-id="element-1258">
                    <div className="flex items-center gap-2" data-id="element-1259">
                      <AlertCircleIcon className="h-4 w-4 text-gray-500" data-id="element-1260" />
                      <span className="text-sm font-semibold text-[#0A1628]" data-id="element-1261">
                        Institución 3
                      </span>
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-1262">Pendiente</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents card - top right */}
            <div className="absolute top-8 right-0 w-[300px] bg-white rounded-2xl shadow-2xl border border-gray-200 p-5 transform rotate-3 hover:rotate-0 transition-transform duration-300" data-id="element-1263">
              <div className="flex items-center gap-2 mb-4" data-id="element-1264">
                <FileCheckIcon className="h-5 w-5 text-[#2B5FD9]" data-id="element-1265" />
                <h3 className="text-base font-bold text-[#0A1628]" data-id="element-1266">
                  Documentos
                </h3>
              </div>
              <div className="space-y-2" data-id="element-1267">
                <div className="flex items-center justify-between bg-[#E8EDF5] rounded-lg p-2" data-id="element-1268">
                  <span className="text-sm text-[#0A1628]" data-id="element-1269">
                    Liquidación sueldo
                  </span>
                  <CheckCircle2Icon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1270" />
                </div>
                <div className="flex items-center justify-between bg-[#E8EDF5] rounded-lg p-2" data-id="element-1271">
                  <span className="text-sm text-[#0A1628]" data-id="element-1272">
                    Carpeta tributaria
                  </span>
                  <CheckCircle2Icon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1273" />
                </div>
                <div className="flex items-center justify-between bg-[#E8EDF5] rounded-lg p-2" data-id="element-1274">
                  <span className="text-sm text-[#0A1628]" data-id="element-1275">Identificación</span>
                  <CheckCircle2Icon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1276" />
                </div>
              </div>
            </div>

            {/* Notification card - bottom left */}
            <div className="absolute bottom-12 left-0 w-[320px] bg-[#1E2A3A] rounded-2xl shadow-2xl p-5 transform -rotate-2 hover:rotate-0 transition-transform duration-300" data-id="element-1277">
              <div className="flex items-center gap-3 mb-3" data-id="element-1278">
                <div className="w-10 h-10 bg-[#2B5FD9] rounded-full flex items-center justify-center" data-id="element-1279">
                  <BellIcon className="h-5 w-5 text-white" data-id="element-1280" />
                </div>
                <div className="flex-1" data-id="element-1281">
                  <h3 className="text-sm font-bold text-white" data-id="element-1282">
                    Nueva actualización
                  </h3>
                  <p className="text-xs text-white/80" data-id="element-1283">Hace 2 minutos</p>
                </div>
              </div>
              <div className="bg-white/10 rounded-lg p-3" data-id="element-1284">
                <p className="text-sm text-white" data-id="element-1285">
                  ✓ Tu solicitud en <strong data-id="element-1286">Institución 1</strong> ha sido
                  pre-aprobada
                </p>
              </div>
            </div>

            {/* Stats card - top left */}
            <div className="absolute top-20 left-4 w-[200px] bg-white rounded-xl shadow-xl border border-gray-200 p-4 transform -rotate-6 hover:rotate-0 transition-transform duration-300" data-id="element-1287">
              <div className="flex items-center gap-2 mb-3" data-id="element-1288">
                <BarChart3Icon className="h-4 w-4 text-[#2B5FD9]" data-id="element-1289" />
                <span className="text-xs font-bold text-[#0A1628]" data-id="element-1290">
                  Resumen
                </span>
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-1291">
                <div className="text-center" data-id="element-1292">
                  <p className="text-xl font-bold text-[#2B5FD9]" data-id="element-1293">1</p>
                  <p className="text-xs text-[#6B7280]" data-id="element-1294">Pre-aprobado</p>
                </div>
                <div className="text-center" data-id="element-1295">
                  <p className="text-xl font-bold text-blue-600" data-id="element-1296">1</p>
                  <p className="text-xs text-[#6B7280]" data-id="element-1297">En revisión</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - Features list */}
          <div className="space-y-4 md:space-y-6 order-1 lg:order-2" data-id="element-1298">
            <div className="flex items-start gap-3" data-id="element-1299">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-lg md:rounded-xl p-0.5 shadow-lg" data-id="element-1300">
                <div className="w-full h-full bg-blue-50 rounded-lg md:rounded-xl flex items-center justify-center" data-id="element-1301">
                  <EyeIcon className="h-5 w-5 md:h-6 md:w-6 text-[#2B5FD9]" data-id="element-1302" />
                </div>
              </div>
              <div data-id="element-1303">
                <h3 className="text-base md:text-lg font-bold text-[#0A1628] mb-1 md:mb-2" data-id="element-1304">
                  Claridad
                </h3>
                <p className="text-xs md:text-sm text-[#6B7280]" data-id="element-1305">
                  Sabes si te aprueban.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-1306">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-lg md:rounded-xl p-0.5 shadow-lg" data-id="element-1307">
                <div className="w-full h-full bg-blue-50 rounded-lg md:rounded-xl flex items-center justify-center" data-id="element-1308">
                  <TargetIcon className="h-5 w-5 md:h-6 md:w-6 text-[#2B5FD9]" data-id="element-1309" />
                </div>
              </div>
              <div data-id="element-1310">
                <h3 className="text-base md:text-lg font-bold text-[#0A1628] mb-1 md:mb-2" data-id="element-1311">
                  Sin conflictos
                </h3>
                <p className="text-xs md:text-sm text-[#6B7280]" data-id="element-1312">
                  Lo mejor para ti.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-1313">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-lg md:rounded-xl p-0.5 shadow-lg" data-id="element-1314">
                <div className="w-full h-full bg-blue-50 rounded-lg md:rounded-xl flex items-center justify-center" data-id="element-1315">
                  <FileCheckIcon className="h-5 w-5 md:h-6 md:w-6 text-[#2B5FD9]" data-id="element-1316" />
                </div>
              </div>
              <div data-id="element-1317">
                <h3 className="text-base md:text-lg font-bold text-[#0A1628] mb-1 md:mb-2" data-id="element-1318">
                  Sin ejecutivos
                </h3>
                <p className="text-xs md:text-sm text-[#6B7280]" data-id="element-1319">
                  Hacemos el papeleo.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-1320">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-lg md:rounded-xl p-0.5 shadow-lg" data-id="element-1321">
                <div className="w-full h-full bg-blue-50 rounded-lg md:rounded-xl flex items-center justify-center" data-id="element-1322">
                  <ZapIcon className="h-5 w-5 md:h-6 md:w-6 text-[#2B5FD9]" data-id="element-1323" />
                </div>
              </div>
              <div data-id="element-1324">
                <h3 className="text-base md:text-lg font-bold text-[#0A1628] mb-1 md:mb-2" data-id="element-1325">
                  Rápido
                </h3>
                <p className="text-xs md:text-sm text-[#6B7280]" data-id="element-1326">
                  Te avisamos al instante.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}